const headerBlock = {
  skipToContent: "Gå til innhold"
};

export default headerBlock;